import { ExternalLink } from 'lucide-react'
import { Link } from 'react-router-dom'

import { ImageContainer } from '@/components'
import { useAuthStore } from '@/features/sessao/store/useAuthStore'
import { Asset, Equipment } from '@/services/backend/config/entities'

type Props = {
  data: Asset & { Equipment?: Equipment }
}

export const Asset_Displayer = ({ data }: Props) => {
  const { user } = useAuthStore()

  return (
    <div className="flex items-center gap-2">
      <ImageContainer src={data.Equipment?.imageStr ?? undefined} className="size-16" />
      <div>
        <p className="text-xl">
          <span className="mr-2 text-xs text-muted-foreground">Patrimônio</span>
          {data.assetNumber}
          {user && (
            <Link to={`/app/entity/patrimonios/${data.id}/detalhes`}>
              <ExternalLink className="ml-2 inline size-3 text-primary" />
            </Link>
          )}
        </p>
        <p className="text-sm text-muted-foreground">
          {data.Equipment?.name ?? data.name}
        </p>
      </div>
    </div>
  )
}
